import { FetchProxy } from "intraactive-sdk-helper";
import { IEnvironment } from "../interfaces/IEnvironment";
import { Environment } from "./Environment";
import { sdkContainerInstance } from "../global/Container";
import { ITargetingV2Application } from "../components/targetingV2/interfaces/ITargetingApplication";
import { ITargetingV2Group } from "../components/targetingV2/interfaces/ITargetingV2Group";
import { ITreeViewItem } from "../interfaces/ITreeViewItem";

export class TargetingV2Service {

  public static getTargetingGroups(environment: IEnvironment, tenant: string, application: ITargetingV2Application, instanceName: string): Promise<{ groupEntries: ITargetingV2Group[] }> {
    return new Promise<{ groupEntries: ITargetingV2Group[] }>((resolve, reject): void => {
      if (environment && tenant) {
        let apiUrl = `${Environment.getEnvironmentForTargetingAPI(environment)}/v2/${tenant}/${application}/groups/${instanceName != undefined ? instanceName : ""}`;
        new FetchProxy(apiUrl,
          {
            method: "GET",
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              throw (response.status);
            } else {
              return response.json();
            }
          }).then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      } else {
        reject(null);
      }
    });
  }

  public static getTargetingStructure(environment: IEnvironment, tenant: string): Promise<ITreeViewItem[]> {
    return new Promise<ITreeViewItem[]>((resolve, reject): void => {
      if (environment && tenant) {
        let apiUrl = `${Environment.getEnvironmentForTargetingAPI(environment)}/v2/${tenant}/targeting-structure`;
        new FetchProxy(apiUrl,
          {
            method: "GET",
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              if (response.status === 404) {
                resolve([]);
              } else {

              }
              throw (response.status);
            } else {
              return response.json();
            }
          }).then(response => {
            resolve(response.structure);
          })
          .catch(error => {
            reject(error);
          });
      } else {
        reject(null);
      }
    });
  }

  public static createTargetingStructure(environment: IEnvironment, tenant: string, targetingStructure): Promise<void> {
    return new Promise<void>((resolve, reject): void => {
      if (environment && tenant) {
        let apiUrl = `${Environment.getEnvironmentForTargetingAPI(environment)}/v2/${tenant}/targeting-structure`;
        new FetchProxy(apiUrl,
          {
            method: "POST",
            body: JSON.stringify(
              { structure: targetingStructure }
            ),
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              reject(response);
              return;
            }
            resolve();
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        reject(null);
      }
    });
  }

  public static updateTargetingStructure(environment: IEnvironment, tenant: string, targetingStructure): Promise<void> {
    return new Promise<void>((resolve, reject): void => {
      if (environment && tenant) {
        let apiUrl = `${Environment.getEnvironmentForTargetingAPI(environment)}/v2/${tenant}/targeting-structure`;
        new FetchProxy(apiUrl,
          {
            method: "PUT",
            body: JSON.stringify(
              { structure: targetingStructure }
            ),
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              reject(response);
              return;
            }
            resolve();
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        reject(null);
      }
    });
  }
}